import i18n from "config/i18n"

function toCurrency(value: number): string {
  // NOTE: will convert value into 1 234,56 €
  const MONEY_LOCALE = "fr-FR"
  const MONEY_CURRENCY = "EUR"

  return new Intl.NumberFormat(MONEY_LOCALE, {
    style: "currency",
    currency: MONEY_CURRENCY,
  }).format(value)
}

function formatMoney(value?: number | string | undefined) {
  if (value) {
    if (typeof value === "number") {
      return toCurrency(value)
    } else {
      return toCurrency(parseFloat(value))
    }
  } else if (value === 0) {
    return toCurrency(value)
  } else {
    return i18n.t("common.not_available")
  }
}

export { formatMoney }
